namespace Matrix.Rebalancer {
    export interface SummaryViewInstanceRow {
        InstanceCode?: string;
        ViewCode?: string;
        Name?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        ViewName?: string;
        ViewRowId?: number;
    }

    export namespace SummaryViewInstanceRow {
        export const idProperty = 'InstanceCode';
        export const nameProperty = 'InstanceCode';
        export const localTextPrefix = 'Rebalancer.SummaryViewInstance';
        export const lookupKey = 'Rebalancer.SummaryViewInstance';

        export function getLookup(): Q.Lookup<SummaryViewInstanceRow> {
            return Q.getLookup<SummaryViewInstanceRow>('Rebalancer.SummaryViewInstance');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            InstanceCode = "InstanceCode",
            ViewCode = "ViewCode",
            Name = "Name",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            ViewName = "ViewName",
            ViewRowId = "ViewRowId"
        }
    }
}
